import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import BraineeQuestionCard from "./assessment/BraineeQuestionCard";
import { Row, Col, Select, Popconfirm, Button, Typography } from "antd";
import { StepBackwardOutlined, StepForwardOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import SimpleBarReact from "simplebar-react";
import "swiper/css";

/**
 * SlideViewQuestions component
 * Props:
 * - answerSheetData
 * - answerData
 * - handleAnswerRequest
 * - swiperRef
 * - handleSlideChange
 * - setIsTransitioning
 * - contentStyle
 * - idxCol
 * - sectionIdx
 * - qcardIdx
 * - location
 */
const SlideViewQuestions = ({
   answerSheetData,
   answerData,
   handleAnswerRequest,
   swiperRef,
   handleSlideChange,
   setIsTransitioning,
   isTransitioning,
   idxCol,
   sectionIdx,
   qcardIdx,
   location,
   questionIndex,
   handleGoTo,
   isSubmitted,
   handleSubmit,
   hasUnansweredQuestions,
   handlePrev,
   handleNext,
   assessment_type,
   onTrustedUploadStart,
   onTrustedUploadEnd,
   mobileVirtualKeyboard,
}) => {
   const simpleBarRef = React.useRef(null);

   let localSectionIdx = sectionIdx;
   let localQcardIdx = qcardIdx;
   let localIdxCol = [...idxCol];

   let optionSectionIdx = sectionIdx;
   let optionQcardIdx = qcardIdx;

   // Scroll to top on slide change
   const onSlideChange = (...args) => {
      if (simpleBarRef.current && simpleBarRef.current.getScrollElement) {
         simpleBarRef.current.getScrollElement().scrollTop = 0;
      }
      if (typeof handleSlideChange === "function") {
         handleSlideChange(...args);
      }
   };

   return (
      <div
         className="answer-sheet-content3 slide-answer-sheet-content"
         style={{ display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 }}
      >
         <SimpleBarReact ref={simpleBarRef} style={{ flex: "1 1 auto", minHeight: 0 }}>
            <Swiper
               onSwiper={swiperRef}
               onSlideChange={onSlideChange}
               onTransitionEnd={() => setIsTransitioning(false)}
               allowTouchMove={true}
               slidesPerView={1}
               spaceBetween={0}
               navigation={false}
               pagination={false}
            >
               {answerSheetData.map(
                  (
                     {
                        id,
                        type,
                        points,
                        option_labels,
                        question,
                        image_url,
                        template,
                        question_image,
                        question_audio,
                        question_video,
                     },
                     idx
                  ) => {
                     if (type === "section") {
                        localQcardIdx = 1;
                        localIdxCol.push(localSectionIdx);
                        localSectionIdx++;
                     } else {
                        localIdxCol.push(localQcardIdx);
                        localQcardIdx++;
                     }

                     return (
                        <SwiperSlide key={id} className="slide-question-item">
                           <div className="question-center-container slide-question-center-container">
                              <BraineeQuestionCard
                                 index={localIdxCol[idx]}
                                 id={idx}
                                 type={type}
                                 points={points}
                                 correct={answerData[idx].answer}
                                 option_labels={option_labels}
                                 question={question}
                                 image_url={image_url}
                                 question_type={"2"}
                                 mode={"answer"}
                                 answerCallback={handleAnswerRequest}
                                 template={template}
                                 question_image={question_image}
                                 question_audio={question_audio}
                                 question_video={question_video}
                                 subject_name={location.state.subject}
                                 assessment_type={assessment_type}
                                 onTrustedUploadStart={onTrustedUploadStart}
                                 onTrustedUploadEnd={onTrustedUploadEnd}
                                 mobileVirtualKeyboard={mobileVirtualKeyboard}
                              />
                           </div>
                        </SwiperSlide>
                     );
                  }
               )}
            </Swiper>
         </SimpleBarReact>

         {/* Navigation section */}
         <div className="assessment-question-navigation">
            <Row className="assessment-question-navigation-row assessment-question-navigation-row-slide" gutter={12}>
               <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button className='button-shadow' type='primary' shape='round' onClick={typeof handlePrev === "function" ? handlePrev : undefined} disabled={isTransitioning || (typeof questionIndex !== "undefined" && (questionIndex <= 1))}>
                     <StepBackwardOutlined />
                  </Button>
               </Col>
               <Col span={12}>
                  {
                     typeof questionIndex !== "undefined" && typeof answerSheetData !== "undefined" && questionIndex === answerSheetData.length
                        ?
                        <Popconfirm
                           title="Click 'Yes', if you have already completed your answers, 'No', if you want to continue answering."
                           onConfirm={typeof handleSubmit === "function" ? handleSubmit : undefined}
                           okText="Yes"
                           cancelText="No"
                           icon={<QuestionCircleOutlined />}
                        >
                           <Button className='button-shadow' type='primary' block shape='round' disabled={typeof isSubmitted !== "undefined" ? isSubmitted : false}>
                              <Typography.Text ellipsis style={{ color: "#fff" }}>Submit Answer</Typography.Text>
                           </Button>
                        </Popconfirm>
                        :
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                           <div>
                              <Select
                                 size="default"
                                 style={{ width: '70px', textAlign: "center", borderRadius: "7px" }}
                                 value={questionIndex}
                                 onChange={typeof handleGoTo === "function" ? handleGoTo : undefined}
                                 disabled={isTransitioning}
                              >
                                 {
                                    answerSheetData.map(({id, type}, idx) => {
                                       if (type === "section") {
                                          optionQcardIdx = 1;
                                          optionSectionIdx++;
                                       } else {
                                          optionQcardIdx++;
                                       }
                                    
                                       return (
                                          <Select.Option key={idx + 1} value={idx + 1}>
                                          {                             
                                             type === "section" ? `S${optionSectionIdx-1}` : optionQcardIdx-1
                                          }
                                          </Select.Option>
                                       );
                                    })
                                 }
                              </Select>
                           </div>
                        </div>
                  }
               </Col>
               <Col span={6} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Button className='button-shadow' type='primary' shape='round' onClick={typeof handleNext === "function" ? handleNext : undefined} disabled={isTransitioning || (typeof questionIndex !== "undefined" && typeof answerSheetData !== "undefined" && (questionIndex === answerSheetData.length))}>
                     <StepForwardOutlined />
                  </Button>
               </Col>
            </Row>
         </div>
      </div>
   );
};

export default SlideViewQuestions;
